<template>
  <b-modal
      :visible="visible"
      title="Please confirm"
      ok-variant="success"
      @hidden="$emit('cancel')"
      @ok="onClickApprove"
      hide-header-close
      centered
  >
    <p>You are going to approve this facility</p>
    <strong v-if="license">{{ `${license.facility.name} - ${license.number}` }}</strong>
    <hr>
    <b-form-checkbox
        v-model="is_to_buy"
        :value="true"
        :unchecked-value="false"
    >
      Permit <strong>Purchase</strong> operations
    </b-form-checkbox>
    <hr>
    <b-form-checkbox
        v-model="is_to_sell"
        :value="true"
        :unchecked-value="false"
    >
      Permit <strong>Sale</strong> operations
    </b-form-checkbox>
  </b-modal>
</template>

<script>
export default {
  name: "AdminLicenseApproveModal",
  emits: ['approve', 'cancel'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    license: {
      type: Object
    }
  },
  data() {
    return {
      is_to_buy: this.license?.is_to_buy,
      is_to_sell: this.license?.is_to_sell
    }
  },
  methods: {
    onClickApprove() {
      this.$emit('approve', {
        license: this.license,
        is_to_buy: this.is_to_buy,
        is_to_sell: this.is_to_sell
      });
    }
  }
}
</script>
